module.exports = __webpack_public_path__ + "img/mi-inventory-2.edaf94df.svg";